import { eventChannel } from 'redux-saga';
import firebase from 'firebase';

// Watch dom events 

export default function createDOMEventListenerChannel() {

    return eventChannel(emitter => {

        window.addEventListener('resize', () => {

            emitter({ type: 'resize' })

        })

        window.addEventListener('click', ev => {

            emitter({type: 'click', ev})

        })
        
        return () => {

            return null

        }

    })
}


// WEBPACK FOOTER //
// ./src/sagas/channel-dom.js